import {
  NodeType,
  ResolvedNodeDefinitions
} from 'Automations/nodeDefinitions/types'
import {
  IntermediateNode,
  IntermediateNodeWithConditionalProperties
} from '../../presentationToConductorWorkflow.types'

// Reads each node's `providesConditionalProperties` from the resolved registry
// (any fetched data — e.g. one switch operator per customer custom-property key
// — is already concrete), recursing into branches and group continuations.
// Curried on `definitions` so it slots into the serialization `flow` pipeline.
export const applyConditionalProperties =
  (definitions: ResolvedNodeDefinitions) =>
  (
    intermediateNodes: IntermediateNode[]
  ): IntermediateNodeWithConditionalProperties[] =>
    intermediateNodes.map(node => {
      if (!node.node.type) throw new Error('nodeType is undefined')
      const definition = definitions[node.node.type as NodeType]

      return {
        ...node,
        branches: node.branches.map(applyConditionalProperties(definitions)),
        groupContinuations: node.groupContinuations
          ? resolveGroupContinuations(node.groupContinuations, definitions)
          : undefined,
        conditionalProperties: definition.providesConditionalProperties ?? {}
      }
    })

const resolveGroupContinuations = (
  groupContinuations: Record<string, IntermediateNode[]>,
  definitions: ResolvedNodeDefinitions
): Record<string, IntermediateNodeWithConditionalProperties[]> =>
  Object.fromEntries(
    Object.entries(groupContinuations).map(([key, nodes]) => [
      key,
      applyConditionalProperties(definitions)(nodes)
    ])
  )
